export const environment = {
  production: false,
  urlMapping: {
    PROJ_API: 'https://kavach-uat.vassardigital.ai/kavach/api/services',
    PROJ_API_URL: 'https://kavach-uat.vassardigital.ai/kavach/api',
    SSE_URL: 'https://kavach-uat.vassardigital.ai/api/sse/conversations',

    // PROJ_API: 'https://74348b1d501c.ngrok-free.app/api/kavach/services',
      USERMGMT_API:"https://kavach-uat.vassardigital.ai/um/",
    //  WEBSOCKET_URL:"wss://dev.ce.vassardigital.ai/ws/chatbot/",
    DOMAIN_URL: "https://kavach-uat.vassardigital.ai/"
  },
  KEYCLOAK_URLS: {
      BASE_URL: 'https://kavach-uat.vassardigital.ai/auth',
      REDIRECT_URL: 'https://kavach-uat.vassardigital.ai/landing',
      LOGOUT_URL: 'https://kavach-uat.vassardigital.ai/login'
  },
       YOLO_CALLBACK_URL: "https://kavach-uat.vassardigital.ai/kavach/api/services/yolo_callback",

    CLIENT_ID: 'kavachusermgmt',
    REALM_NAME: 'KavachUM'

};
